// Browser credentials live only in HttpOnly cookies. Native credentials use the Android Keystore bridge.
export interface SecureSessionStore {
    get(): Promise<{ token: string | null }>;
    set(input: { token: string }): Promise<void>;
    remove(): Promise<void>;
}
export function createSessionStorage(native: boolean, secure: SecureSessionStore, legacy: Pick<Storage, 'removeItem'>) {
    const cleanLegacy = () => {
        // Cookie authentication still works when browser storage is disabled.
        try {
            legacy.removeItem('accessToken');
            legacy.removeItem('refreshToken');
        } catch { /* Best-effort removal of obsolete credentials. */ }
    };
    return {
        async getToken(): Promise<string | null> {
            cleanLegacy();
            return native ? (await secure.get()).token : null;
        },
        async save(session: { sessionToken?: string }) {
            cleanLegacy();
            if (native) {
                if (!session.sessionToken || !/^[A-Za-z0-9_-]{43}$/.test(session.sessionToken)) throw new Error('Sign-in did not return a session token');
                await secure.set({ token: session.sessionToken });
            }
        },
        async clear() {
            cleanLegacy();
            if (native) await secure.remove();
        },
    };
}
